/* eslint-disable no-param-reassign */
import React, { Suspense } from 'react';
import ReactDOM from 'react-dom';
import { I18nextProvider } from 'react-i18next';

import { createGlobalStyle, ThemeProvider } from 'styled-components';
import { DndProvider } from 'react-dnd';
import { HTML5Backend } from 'react-dnd-html5-backend';

import * as Sentry from '@sentry/react';
import { Integrations } from '@sentry/tracing';
// eslint-disable-next-line import/extensions
import 'bootstrap/dist/css/bootstrap.css';
// eslint-disable-next-line import/extensions
import 'bootstrap/dist/js/bootstrap.min.js';

import Bowser from 'bowser';
import themeStyles from './Constants/theme';

import App from './App';
import PasswordReset from './pages/PasswordReset/PasswordReset';
import ErrorBoundary from './ErrorBoundary';

import i18n from './i18n';

import 'animate.css';

require('dotenv').config();

let userSelect = '';
const isCorrectBrowser = () => {
    const useragent = navigator.userAgent;
    const browser = Bowser.getParser(useragent);
    const { name: browserName, version } = browser.parsedResult.browser;
    return browserName;
};

if (isCorrectBrowser() === 'Safari') {
    userSelect = `
    *{
        user-select: text;
        -webkit-touch-callout: text ; /* iOS Safari */
        -webkit-user-select: text; /* Safari */
         -khtml-user-select: text; /* Konqueror HTML */
           -moz-user-select: text; /* Old versions of Firefox */
            -ms-user-select: text; /* Internet Explorer/Edge */
    }
    .flipper[rotate='1'] {
        transform: rotateY(181deg);
    }`;
} else {
    userSelect = `
    *{
        user-select: none;
        -webkit-touch-callout: none ; /* iOS Safari */
        -webkit-user-select: none; /* Safari */
         -khtml-user-select: none; /* Konqueror HTML */
           -moz-user-select: none; /* Old versions of Firefox */
            -ms-user-select: none; /* Internet Explorer/Edge */
    }
    .flipper[rotate='1'] {
        transform: rotateY(180deg);
    }`;
}

const GlobalStyle = createGlobalStyle`
    ${userSelect}

    :root {
        --progress-end-top: 0vh;
        --progress-end-right: 0vw;
    }

    * {
        margin: 0;
        padding: 0;
        box-sizing: border-box;
    }

    #root {
        height: 100vh;
        width: 100vw;
    }

    body {
        font-family: 'Roboto', sans-serif;
    }

    .Player[data-progress='1'] {
        transform: translate(var(--progress-end-right), var(--progress-end-top));
    }
`;

// Fix Sentry
// if (window.location.hostname != 'localhost')
//     Sentry.init({
//         dsn: 'https://702b340e33d246b5b171a6fb13770ab2@o375167.ingest.sentry.io/5856929',
//         integrations: [new Integrations.BrowserTracing()],
//         attachStacktrace: true,
//         environment: process.env.NODE_ENV,

//         // Set tracesSampleRate to 1.0 to capture 100%
//         // of transactions for performance monitoring.
//         // We recommend adjusting this value in production
//         tracesSampleRate: 1.0,
//     });

// setTimeout(() => {
//     try {
//         aFunctionThatMightFail();
//     } catch (err) {
//         console.log('sentry call');
//         Sentry.captureMessage('Breadcrumb  test');
//     }
// }, 60000);

ReactDOM.render(
    <React.StrictMode>
        <ThemeProvider theme={themeStyles}>
            <GlobalStyle />
            <ErrorBoundary>
                <I18nextProvider i18n={i18n}>
                    <Suspense fallback={<div>Loading...</div>}>
                        {window.location.pathname === '/reset-password' ? (
                            <PasswordReset />
                        ) : (
                            <App />
                        )}
                    </Suspense>
                </I18nextProvider>
            </ErrorBoundary>
        </ThemeProvider>
    </React.StrictMode>,
    document.getElementById('root'),
);
